/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore'
import { classify, modelType, popRootKey } from './util'

import MultipleChoicePoll from './models/multiple_choice_poll'
import FreeTextPoll from './models/free_text_poll'
import Discourse from './models/discourse'
import ClickableImage from './models/clickable_image'
import RankingPoll from './models/ranking_poll'
import Survey from './models/survey'
import Competition from './models/competition'
import JoinInstructions from './models/join_instructions'

const activityModels = {
  MultipleChoicePoll,
  FreeTextPoll,
  Discourse,
  ClickableImage,
  RankingPoll,
  Survey,
  Competition,
  JoinInstructions
}

/**
 * Adds a group.id attribute to the provided object argument.
 * If no attribute exists, it is created and normalized to -1.
 *
 * @param {Object} attrs Object to add group ID attribute to.
 */
function initGroupId (attrs) {
  // Don't do anything if it's not object
  if (typeof attrs !== 'object') { return attrs }
  // Don't do anything if it's array
  if (Array.isArray(attrs)) { return attrs }
  // Don't do anything if group_id exists
  if (attrs.group_id) { return attrs }
  // Don't do anything if competition_id exists
  if (attrs.competition_id) { return attrs }
  // Don't do anything if survey_id exists
  if (attrs.survey_id) { return attrs }

  const clonedAttrs = JSON.parse(JSON.stringify(attrs))
  // This is the new location of group_id within the response.
  clonedAttrs.group_id = -1
  return clonedAttrs
}

export default function (json, options) {
  /*
   * There may be cases where we bootstrap with an empty JSON value
   * (e.g., poll has no owner) so just return nothing and get out of here.
   */
  if (_(json).isEmpty()) { return }

  const type = modelType(json)
  let attrs = popRootKey(json)
  attrs = initGroupId(attrs)
  /*
   * TODO: Different endpoints provide different formats of this type, some are
   * snake case and some are capitalized camelcase. Backend needs to be
   * consistent.
   */
  const activityType = classify(type) || type
  const ActivityClass = activityModels[activityType]

  // return nothing if poll type doesn't exist yet
  if (ActivityClass) {
    return new ActivityClass(attrs, options)
  }
}
